import React, { useEffect, ReactNode } from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import Radio from '@components/UI-KIT/Radio';
import CardItem from '@components/UI-KIT/CardItem';
import Footer from '@components/UI-KIT/Footer';
import Button from '@components/UI-KIT/Button';

// Icons
import { Income, Outgoing, MovementOutlined } from '@/assets/icons';
import AmountInput from '../../../UI-KIT/Inputs/AmountInput/index';


interface Props {
    transactionType: string;
    setTransactionType: React.Dispatch<React.SetStateAction<string>>;
    setActiveStep: React.Dispatch<React.SetStateAction<number>>;
    setTransaction: React.Dispatch<React.SetStateAction<{ amount: number }>>;
    setTransactionBetween: React.Dispatch<React.SetStateAction<{ amount: number }>>;
    transactionBetween: {
        amount: number
    }
    transaction: {
        amount: number
    };
    setDrawer: React.Dispatch<React.SetStateAction<{
        drawerOpened: boolean;
        drawerTitle: ReactNode | string;
        drawerChildren: ReactNode;
        drawerFooter: boolean;
        titleIcon: ReactNode;
    }>>;
};

const FirstStep: React.FC<Props> = ({
    transactionType,
    setTransactionType,
    setActiveStep,
    setTransaction,
    setTransactionBetween,
    transactionBetween,
    transaction,
    setDrawer
}) => {

    useEffect(() => {
        setDrawer(prevState => ({
            ...prevState,
            titleIcon: null,
            drawerTitle: 'Nueva transacción'
        }));
    }, [ ]);

    return (
        <>
            <Grid
                container
                direction="column"
                spacing={3}
            >
                <CardItem
                    onHoverEffect
                    tooltip="Ingreso te permite registrar la entrada de dinero a una cuenta, siempre que no sea una liquidación a propietario o cobro de alquiler y servicios asociados."
                    variant={transactionType === 'Income' ? 'outlined' : 'normal'}
                    onClick={() => transactionType !== 'Income' && setTransactionType('Income')}
                >
                    <Radio
                        checked={transactionType === 'Income'}
                    />
                    <Income />
                    <Typography
                        variant="h4"
                        color="primary-dark"
                        className="AOL-Account-stepper-label"
                    >
                        Ingreso
                    </Typography>
                </CardItem>
                <CardItem
                    onHoverEffect
                    tooltip="Egreso te registra la salida dinero de una cuenta previamente agregada. También podrás asociarla a un propietario, inquilino o administración."
                    variant={transactionType === 'Outgoing' ? 'outlined' : 'normal'}
                    onClick={() => transactionType !== 'Outgoing' && setTransactionType('Outgoing')}
                >
                    <Radio
                        checked={transactionType === 'Outgoing'}
                    />
                    <Outgoing />
                    <Typography
                        variant="h4"
                        color="primary-dark"
                        className="AOL-Account-stepper-label"
                    >
                        Egreso
                    </Typography>
                </CardItem>
                <CardItem
                    onHoverEffect
                    tooltip="Registra un movimiento de dinero entre cuentas previamente agregadas."
                    variant={transactionType === 'Movement' ? 'outlined' : 'normal'}
                    onClick={() => transactionType !== 'Movement' && setTransactionType('Movement')}
                >
                    <Radio
                        checked={transactionType === 'Movement'}
                    />
                    <MovementOutlined />
                    <Typography
                        variant="h4"
                        color="primary-dark"
                        className="AOL-Account-stepper-label"
                    >
                        Movimiento
                    </Typography>
                </CardItem>
                <AmountInput
                    variant="outlined"
                    label="¿Cuánto dinero?"
                    value={transactionType !== 'Movement' ? transaction.amount : transactionBetween.amount}
                    onChange={(amount: number) => {
                        setTransaction(prevState => ({
                            ...prevState,
                            amount,
                            multiplier: transactionType === 'Outgoing' ? -1 : 1
                        }));
                        setTransactionBetween(prevState => ({
                            ...prevState,
                            amount
                        }));
                    }}
                />
            </Grid>
            <Footer
                className="AOL-Account-stepper-footer"
            >
                <Grid
                    container
                    direction="column"
                >
                    <Button
                        label="Siguiente"
                        disabled={transactionType !== 'Movement' ? !transaction.amount : !transactionBetween.amount }
                        onClick={() => setActiveStep(prevState => prevState + 1)}
                    />
                </Grid>
            </Footer>
        </>
    );
};

export default FirstStep;